import { observer } from "mobx-react";
import { IValidationGroup } from "../../../../../../../hooks/validation-group/validation-group-hook";
import { FormFieldLine } from "../../../../../../../components/form-field-line/form-field-line";
import { Input } from "../../../../../../../components/inputs/input/input";
import KExpressCredentialsStore from "../../../../stores/credentials/shipping/k-express-credentials-store";

interface IProps {
    credentialsStore: KExpressCredentialsStore,
    vGroup: IValidationGroup,
}

const KExpressCredentials: React.FC<IProps> = observer(({
                                                            credentialsStore,
                                                            vGroup,
                                                        }) => {
    return (
        <>
            <FormFieldLine
                required
                label='K-Express Api Token'
                key='api_token'
                note='Your K-Express Api Token'
            >
                <Input
                    value={credentialsStore.apiToken}
                    onChange={credentialsStore.setApiToken}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='K-Express Customer ID'
                key='customer_id'
                note='Your K-Express Customer Number'
            >
                <Input
                    value={credentialsStore.customerId}
                    onChange={credentialsStore.setCustomerId}
                    validationGroup={vGroup}
                />
            </FormFieldLine>
        </>
    );
});

export default KExpressCredentials;